import { ORDER_MASTER_REQUEST } from 'constants/action-types';

export const fetchOrderMaster = () => ({
  type: ORDER_MASTER_REQUEST,
  payload: {
    request: {
      url: 'selling/order/master',
      method: 'GET',
      headers: {
        'Cache-Control': 'no-cache'
      }
    }
  }
});



// WEBPACK FOOTER //
// ./src/actions/orderAggregators/purchase.js